import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { useEffect, useState } from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader, Spinner, FormFeedback } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { conditionType } from '../data/jsonData'
import Select from 'react-select'


class PosStorePriceModificationForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isLoading:false,
      isEdit: false,
      isCopy: false,
      productList: [],
      selected_product:null,
      store_id: '',
      id: '',
      product_id: '',
      condition_type: '',
      params: '',
      start_dt: '',
      end_dt: '',
      condition_list: conditionType,
      paramsInvalid:false,
      paramsInvalidText:''
    }
  }

  componentDidMount() {
    let data = this.props.data
    if (this.props.data.isEdit || this.props.data.isCopy) {
      let sdata = this.props.data.product_condition.find(x => x.id == this.props.data.selectedId)
      let filter_condition_list = conditionType
      let condition_list = []

      let product_condition = this.props.data.product_condition.filter(x => x.product_id == sdata.product_id)
      let selected_product = this.props.data.productList.find(x=>x.id == sdata.product_id)

      for (let i of product_condition) {
        condition_list.push(i.condition_type)
      }
      //filter_condition_list = this.state.condition_list.filter(value => !condition_list.includes(value))
      console.log(this.props.data.isEdit)
      console.log(sdata.condition_type)
      this.setState({
        isEdit: data.isEdit,
        isCopy: data.isCopy,
        id: sdata.id,
        store_id: data.store_id,
        product_id: sdata.product_id,
        // condition_type: this.props.data.isEdit ? sdata.condition_type : '',
        condition_type:  sdata.condition_type,
        params: sdata.params,
        start_dt: sdata.start_date,
        end_dt: sdata.end_date,
        productList: data.productList,
        condition_list: filter_condition_list,
        selected_product: [{label:selected_product.product_no + " "+selected_product.name, value:selected_product.id}]
      })
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        productList: data.productList,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  productHandler = event => {
    let { name, value } = event.target

    let condition_list = []

    let product_condition = this.props.data.product_condition.filter(x => x.product_id == value)

    for (let i of product_condition) {
      condition_list.push(i.condition_type)
    }

    let filter_condition_list = this.state.condition_list.filter(value => !condition_list.includes(value))

    this.setState({
      [event.target.name]: event.target.value,
      condition_type: '',
      condition_list: filter_condition_list,
    })
  }

  productMultipleHandler = selected_product => {
   
    this.setState({
      selected_product: selected_product,
    })
  }

  validateQuantity = (value) =>{
    const intValue = parseInt(value, 10);
    return intValue >= 1 && intValue <= 1000;
  }

  validateAvailableDays = (days) => {
    if (!days) return false;
    const validDays = ["Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"];
    const inputDays = days.split(";");
  
    return inputDays.every(day => validDays.includes(day));
  };

  validateConditionParams = (condition, params) => {
    if(condition == 'Available Days'){
      if(params == ""){
        this.setState({paramsInvalid:true, paramsInvalidText:'params cannot be empty if condition set to Available Days'});
        return false;
      }else{
        //console.log(this.validateAvailableDays(this.state.params));
        if(this.validateAvailableDays(params)){
          return true;
        }else{
          this.setState({paramsInvalid:true, paramsInvalidText:'Available Days only accept value like : Mon;Tues'});
          return false;
        }
      }
    }else if(condition == 'MaxQuantity' || condition =='MinQuantity'){
      if(params == ""){
        this.setState({paramsInvalid:true, paramsInvalidText:'params need value between 1 to 1000'});
        return false;
      }else{
        if(this.validateQuantity(params)){
          return true;
        }else{
          this.setState({paramsInvalid:true, paramsInvalidText:'params need value between 1 to 1000'});
          return false;
        }
      }
    }
    else{
      this.setState({paramsInvalid:false, paramsInvalidText:''});
      return true;
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    if(this.validateConditionParams(this.state.condition_type, this.state.params)){
      if (!this.state.isEdit) {
        if(this.state.isCopy){
          if(this.state.selected_product.length>0){
            this.setState({isLoading:true})
          this.copy(user, comp, url)
          }else{
            this.notificationSystem.addNotification({
              title: '',
              message: 'Please select at least 1 product',
              level: 'info',
              position: 'tc',
              autoDismiss: 2,
              dismissible: 'click',
            })
          }
        }else{
          this.create(user, comp, url)
        }
      } else {
        this.edit(user, comp, url)
      }
    }
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      product_id: this.state.product_id,
      condition_type: this.state.condition_type,
      start_date: this.state.start_dt,
      end_date: this.state.end_dt,
      params: this.state.params,
      created_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/condition/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'Product Condition added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  async copy(user, comp, url) {

    // setTimeout(()=>{
    //   this.setState({isLoading:false})
    // }, 5000)
  let count = 0

  let result = await this.state.selected_product.map(i=>{
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      product_id: i.value,
      condition_type: this.state.condition_type,
      start_date: this.state.start_dt,
      end_date: this.state.end_dt,
      params: this.state.params,
      created_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/condition/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.setState({isLoading:false})
          this.props.closeModal(<MdClear />, result.message, 'error', false)

          
          return
        }
        count++
        console.log(count)
        return
      })
      .catch(error => {
        alert(error)
        this.setState({isLoading:false})
        this.props.closeModal(<MdClear />, 'Error', 'error', false)
      })
  })
  
    // if(result.length >= this.state.selected_product.length){
    //   this.setState({isLoading:false})
    //   this.props.closeModal(<MdDone />, 'Product Condition added successfully.', 'success', true)
    // }
    setTimeout(() => {
      this.setState({isLoading:false})
      this.props.closeModal(<MdDone />, 'Product Condition added successfully.', 'success', false)
    }, this.state.selected_product.length * 100);
  }

  edit(user, comp, url) {
    let price_data = [{ unit: this.state.unit, price: this.state.price }]

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      condition_id: this.state.id,
      store_id: this.state.store_id,
      product_id: this.state.product_id,
      condition_type: this.state.condition_type,
      start_date: this.state.start_dt,
      end_date: this.state.end_dt,
      params: this.state.params,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/store/detail/condition/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Product Condition updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {

    let options = [
      ...this.state.productList
        .reduce((r, o) => {
          let key = o.id;
          let item = { value: o.id, label: o.product_no + " " +o.name };
          return r.set(key, item);
        }, new Map())
        .values(),
    ];

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
          <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
           {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <ModalHeader toggle={this.props.onToggleModal()}>Product Condition</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Product</Label>
                {
                  this.state.isCopy ? 
                  <Select
                    isMulti
                    //defaultValue = {[options[defaultIndex]]}
                    value= {this.state.selected_product}
                    options={options}
                    name="product_id"
                    //onChange={setselectedservices}
                    onChange={this.productMultipleHandler}
                    menuPosition={'fixed'}
                    required
                  />
                  :
                  <Input type="select" name="product_id" value={this.state.product_id} onChange={this.productHandler} disabled={this.state.isEdit} required>
                    <option></option>
                    {this.state.productList.length > 0 &&
                      this.state.productList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.product_no} - {item.name}
                          </option>
                        )
                      })}
                  </Input>
                }
              </FormGroup>
              <FormGroup>
                <Label>Condition Type</Label>
                <Input type="select" name="condition_type" value={this.state.condition_type} onChange={this.changeHandler} disabled={this.state.isEdit || this.state.isCopy} required>
                  <option>{this.state.condition_type}</option>
                  {this.state.condition_list.length > 0 &&
                    this.state.condition_list.map(item => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      )
                    })}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Start Date</Label>
                <Input type="date" name="start_dt" value={this.state.start_dt} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>End Date</Label>
                <Input type="date" name="end_dt" value={this.state.end_dt} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Params</Label>
                <Input type="text" name="params" value={this.state.params} onChange={this.changeHandler} invalid={this.state.paramsInvalid}/>
                <FormFeedback>{this.state.paramsInvalidText}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosStorePriceModificationForm
